import { Box, Skeleton as MuiSkeleton, Stack } from '@mui/material';

export const Skeleton = ({ width }: { width?: string }) => (
  <Box
    sx={({ palette }) => ({
      border: `1px solid ${palette.neutral[300]}`,
      borderRadius: 1,
    })}
    data-testid="resource-card-skeleton"
  >
    <MuiSkeleton
      variant="rectangular"
      width={width || 350}
      height={100}
      sx={{ borderTopRightRadius: 1, borderTopLeftRadius: 1 }}
    />
    <Stack spacing={2} flex={1} p={3} height={200}>
      <MuiSkeleton variant="rounded" width="70%" height={20} />
      <MuiSkeleton variant="rounded" width="50%" height={16} />
      <MuiSkeleton variant="rounded" width="30%" height={14} />
    </Stack>
  </Box>
);
